import React,{ useState, useEffect } from 'react';
import styled from 'styled-components';
import { useMutation, useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';
import {  useHistory } from 'react-router-dom';


import { textAreaStyle } from '../styles/includes/forms'

// Components
import StyledPageContent from '../components/StyledPage';
import Field from '../components/InputField';
import Button from '../components/Button';
import InputFile from '../components/InputFile';
import Label from '../components/InputLabel';
import OptionList from '../components/InputOptionList';
import FormErrors, { trowError } from '../components/FormErrors';
import Loading from '../components/Loading';
import InputFileUpload from '../components/InputFileUpload';
import InputImageCrop from '../components/InputImageCrop';


import AcreditacionProfile, { UPDATE_PROFILE ,GET_PROFILE, listGenero  } from '../models/AcreditacionProfile';


const StyledPage = styled(StyledPageContent)`
  .photo-input-file-wrapper {
    margin-top: 2rem
  }
`

const StyledForm = styled.form`
  h1 {
    margin-bottom: 2.5rem;
  }
  h2 {
    margin: 1.5rem 0;
  }
  h3 {
    margin: 1.3rem 0;
  }
  textarea {
    ${textAreaStyle}
    width: 100%;
    height: 80px;
    padding: 12px;
  }
  .field {
    margin-bottom: 1rem;
  }
  .page-footer {
    text-align: center;
    margin-top: 2rem
  }
  .sample-photo {
    max-width: 120px;
    margin: auto;
    img {
      box-shadow: var(--base-box-shadow);
      width: 100%;
    }
  }
`

export default  () => {
    let history = useHistory();

    let UserInfo=AcreditacionProfile.getProfile();
    
    const [ validateAcreditationForm, { loading:loadingForm }] = useMutation(UPDATE_PROFILE);
    const { control, register, handleSubmit, reset } = useForm();
    const [submitError,setSubmitError] = useState<null|string>(null);

    const onSubmit = async (data:any) => {
        console.log('on Send data:',data);
        try{
            let {repeat_password, ...dataChange}=data;
            let response=await validateAcreditationForm({ 
                variables:{
                    input:{
                        ...dataChange
                    },
                    profile_uuid:UserInfo.uuid,
                },
                context:{
                    clientName: 'LOGIN',
                }
            });

            if(response.errors)
                throw new trowError(response.errors);            

            history.push('micuenta')
        }catch(e){
            console.error(e);
            setSubmitError(e);
            window.scrollTo(0,0);
        }
    }

    const { loading, error, data } = useQuery(GET_PROFILE,{
        variables:{
            profile_uuid:UserInfo.uuid,
        }
    });

    useEffect(() => {
        console.log('on Load data:',data);
        if(data && data.getAcreditacionProfile)
            reset({
                ...data.getAcreditacionProfile,
            });
    },[data]);

    if(loading)
        return <Loading /> 

        
    

    return (
        <StyledPage>
            <StyledForm onSubmit={handleSubmit(onSubmit)}>
                <h1>Editar perfil </h1>
                <hr/>
                {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
                <section>
                    <h2>Datos personales</h2>
                    <Field label='Nombre(s)' name='' disabled defaultValue={data?.getAcreditacionProfile?.name} ></Field>
                    <Field label='Apellido Paterno' name='' disabled defaultValue={data?.getAcreditacionProfile?.last_name} ></Field>
                    <Field label='Apellido Materno' name='' disabled defaultValue={data?.getAcreditacionProfile?.second_last_name} ></Field>
                    <Field label='Teléfono celular' name='tel_cell' ref={register}></Field>
                    <Field label='Fecha de nacimiento' name='birth_date' type='date' ref={register}></Field>
                    <div className="field">
                        <Label>Género</Label>
                        <OptionList name='gender' options={listGenero}   disabled  defaultValue={data?.getAcreditacionProfile?.gender} />
                    </div>                    
                </section>
                <hr/>
                {/*
                <section>
                    <h2>Fotografía</h2>
                    <div className="photo-input-file-wrapper text-center">
                        <InputImageCrop label="Seleccionar archivo" name="avatar_key" ref={register}  config={{width: 250, height: 350, output: {width: 250, height: 350}}}/>
                    </div>
                    <div className="field">
                        <Label>Foto de la INE</Label>    
                        <InputFileUpload  accept="image/*" label="Foto frente" name="id_front_key" ref={register}/>
                        <InputFileUpload  accept="image/*" label="Foto reverso" name="id_back_key" ref={register}/>
                    </div>
                </section>
                */}
                <div className="page-footer">
                    <Button type='submit'  disabled={loadingForm}>Guardar</Button>
                </div>
            </StyledForm>
        </StyledPage>
    )
}
